import { Navigate } from "react-router-dom";
import Layout from "@common/components/Layout";
import Login from "@common/pages/Login";
import Register from "@student/pages/Register";
import CoursePlayer from "./pages/CoursePlayer";
import Leaderboard from "./pages/Leaderboard";
import Quiz from "./pages/Quiz";

const studentRoutes = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/",
    element: <Layout />,
    routes: [
      {
        path: "",
        element: <Navigate to="/course" replace />,
      },
      {
        path: "/course",
        element: <CoursePlayer />,
      },
      {
        path: "/leaderboard",
        element: <Leaderboard />,
      },
      {
        path: "/quiz/:id",
        element: <Quiz />,
      },
    ],
  },
];

export default studentRoutes;
